import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';

import { CustomFormsModule } from 'ng2-validation'

import { CanActivateViaOAuthGuard } from '../oAuth.canActivateGuard';
import { CustomDisabledDirective } from '../shared/directives/custom-disabled.directive';
import { FocusDirective } from '../shared/directives/focus.directive'
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { CustomerMsZehutFilter } from '../shared/pipes/custom-ms-zehut-filter.pipe';
import { OnlyNumber } from '../shared/directives/only-number.directive';
import { OrderBy } from '../shared/pipes/order-by.pipe';
import { NofeshPricesComponent } from './nofesh-prices/nofesh-prices.component';
 import { ModalComponent } from '../shared/modal/modal.component';
import { NofeshUploadsComponent } from '../nofesh/nofesh-uploads/nofesh-uploads.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePickerModule} from '@progress/kendo-angular-dateinputs';
import { UserMessagesComponent } from './user-messages/user-messages.component';
import { SpinnerComponent } from './spinner/spinner/spinner.component';
import { ConfirmDialogComponent } from './dialog/confirm-dialog/confirm-dialog.component';
import {MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { NofshonReservationTimerService } from './timer/nofshon-reservation-timer.service';
import { NofshonReservationTimerComponent } from './timer/nofshon-reservation-timer/nofshon-reservation-timer.component';




@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        BrowserModule,
        CustomFormsModule,
        BrowserAnimationsModule,
        TabsModule.forRoot(),
        AccordionModule.forRoot(),
        DatePickerModule
    ],
    declarations: [
        CustomDisabledDirective,
        FocusDirective,
        CustomerMsZehutFilter,
        OnlyNumber,
        OrderBy, 
        NofeshPricesComponent,
        ModalComponent,
        NofeshUploadsComponent,
        UserMessagesComponent,
        NofshonReservationTimerComponent
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        BrowserModule,
        CustomFormsModule,
        TabsModule,
        AccordionModule,
        CustomDisabledDirective,
        FocusDirective,
        CustomerMsZehutFilter,
        OnlyNumber,
        OrderBy, 
        NofeshPricesComponent,
        ModalComponent,
        NofeshUploadsComponent, 
        DatePickerModule,
        UserMessagesComponent,
        NofshonReservationTimerComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    providers: 
    [
        CanActivateViaOAuthGuard,
        NofshonReservationTimerService
    ]
})

export class SharedModule { }
